import React, {useContext, useEffect} from 'react'
import SetValueField from '@components/fields/SetValueField'
import dayjs from '@helpers/dayjs'
import useWebsiteId from '@hooks/useWebsiteId'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import Select from '@packages/justo-parts/lib/components/fields/Select'
import {CheckoutContext} from '@page-components/Checkout/Checkout/CheckoutContext'
import gql from 'graphql-tag'
import isEqual from 'lodash/isEqual'
import {Field} from 'simple-react-form'

import styles from './styles.module.css'

export default function TimeField(props) {
  const {days} = props
  const {timeOptions, setTimeOptions} = useContext(CheckoutContext)
  const websiteId = useWebsiteId()
  const date = dayjs()
    .add(days, 'days')
    .startOf('day')
    .add(3, 'hours') // to fix tz issues
    .format()

  const {preferences} = useQuery({
    query: gql`
      query getTimeOptions($websiteId: ID, $date: Date) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          timeOptions(date: $date) {
            label
            value
            disabled
          }
        }
      }
    `,
    variables: {
      websiteId,
      date
    },
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    if (preferences && preferences.timeOptions) {
      const queryOptions = preferences.timeOptions.map(option => ({
        ...option,
        isDisabled: option.disabled
      }))

      const isAnyOptionEnabled = queryOptions.some(option => !option.disabled)
      const options = isAnyOptionEnabled ? queryOptions : []

      // We do the length check first as it is less expensive than a deep comparison
      if (options.length !== timeOptions?.length) {
        setTimeOptions(options)
      } else if (!isEqual(options, timeOptions)) {
        setTimeOptions(options)
      }
    } else {
      if (timeOptions?.length !== 0) {
        setTimeOptions([])
      }
    }
  }, [preferences, setTimeOptions, timeOptions])

  if (!timeOptions || !timeOptions.length) {
    return <p>Este día no tiene horarios disponibles</p>
  }

  if (timeOptions.length === 1) {
    const {label, value} = timeOptions[0]
    return (
      <>
        <div className={styles.label}>Hora de entrega</div>
        <div className={styles.value}>{label}</div>
        <Field fieldName="time" type={SetValueField} setValue={value} />
      </>
    )
  }

  return (
    <Field
      fieldName="time"
      placeholder="Selecciona la hora"
      noOptionsMessage={() => 'No estamos abiertos este día'}
      type={Select}
      options={timeOptions}
      passProps={{
        ...props.selectorProps,
        menuPlacement: 'top',
        styles: {
          ...props.selectorProps?.styles,
          option: (styles, {isDisabled}) => {
            return {
              ...styles,
              textDecoration: isDisabled ? 'line-through' : styles.textDecoration,
              cursor: isDisabled ? 'not-allowed' : 'default'
            }
          }
        }
      }}
    />
  )
}
